import { styled } from '@mui/system'
import { Card, Stack } from '@mui/material'

const Container = styled(Card)`
  flex: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
`

const Body = styled(Stack)`
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 8px;
`
export { Container, Body }
